import React, { ReactNode } from "react";
import DataLossPreventionIcon from "../icons/DataLossPreventionIcon";
import { Stack, Text } from "@chakra-ui/react";

const NoSearchResult = ({ children, icon }: { children: ReactNode; icon?: ReactNode }) => {
  return (
    <Stack gap={1} align="center" bgColor="brand.100" borderRadius="8px" p={{ base: 5, md: 6 }}>
      {icon ? icon : <DataLossPreventionIcon boxSize={16} color="textGray" />}
      <Text>{children}</Text>
    </Stack>
  );
};

export default NoSearchResult;
